<template>
  <div class="levelTestNav flex">
    <router-link class="line2" to="/admin/level-test/problems/manage">
      문제 풀 관리
    </router-link>
    <router-link class="line2" to="/admin/level-test/config">
      출제 설정
    </router-link>
    <router-link class="line2" to="/admin/level-test/sessions/manage">
      제출 세션 검토
    </router-link>
  </div>
</template>

<script>
export default {
  name: "levelTestNavigation",
};
</script>

<style scoped lang="scss">
.levelTestNav {
  gap: 8px;
  flex-wrap: wrap;
  a {
    margin-left: 0;
  }
}

.levelTestNav .router-link-exact-active {
  background: #3f6ad8;
  color: #fff;
  border-color: #3f6ad8;
}
</style>
